import React, { useEffect, useState } from "react";
import classes from './padlocksList.module.css'
import DataManager from "../../hooks/DataManager";
import ListCard from "../../components/GridList/ListCard";
import BasicTable from "../../components/Table/Table/Table";
import Pill_Widget from "../../components/UI/Widgets/Pill_Widget";
import { useDispatch, useSelector } from 'react-redux';
import Button1 from "../../components/UI/Button/Button1";
import { Await, useNavigate } from "react-router-dom";
import { format } from 'date-fns';
import useSetCookie from "../../components/hooks/UseSetCookie";
import { serviceActions } from "../../store/service-Slice";
import SearchBar from "../SearchView/Search/SearchBar";
import { getGroups } from "../../Api Methods/Api";
import armed from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/armed.png"
import disarmed from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/disarmed.png"
import pulsed from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/pulsed.png"
import locked from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/locked.png"
import unlocked from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/unlocked.png"
import otp from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/OTP.png"
import input_on from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/input_on.png"
import input_off from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/input_off.png"
import update from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/update.png"
import add from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/add.png"
import added from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/added.png"
import used_otp from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/used_otp.png"
import unlocked_unopened from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/unlocked_unopened.png"
import delete_pin from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/delete_pin.png"
import deleted from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/deleted.png"
import incorrect_pin from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/incorrect_pin.png"
import linked from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/linked.png"
import unlinked from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/unlink.png"
import invited from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/invited.png"
import offline from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/offline.png"
import online from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/online.png"
import not_received from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/schedule_failed.png"
import accepted from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/accepted.png"
import left from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/left.png"
import camect from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/camect.png"
import copy_users from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/copyUsers.png"
import override from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/override.png"
import warning from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/warning.png"
import changeRole from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/DropdownIcons/swap.png"
import gateway from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/gateway.png"

const PadlockEvents = ({ events }) => {
    console.log(events)

    const iconMapping = [
        armed,
        disarmed,
        pulsed,
        locked,
        unlocked,
        otp,
        input_off,
        input_on,
        update, 
        add, 
        added, 
        used_otp, 
        unlocked_unopened, 
        delete_pin, 
        deleted, 
        incorrect_pin, 
        linked, 
        unlinked, 
        invited, 
        offline, 
        online, 
        not_received, 
        accepted, 
        left, 
        camect, 
        copy_users, 
        override, 
        warning, 
        changeRole, 
        gateway
    ]

    let tableColumns = [
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Action</h3>
                </div> 
            ),
            accessorKey: 'eventData',
             cell: (row) => {
                const subType = row.row.original.subType;
                const eventData = row.row.original.eventData;
                let recipientName = row.row.original.recipientName;
                if (recipientName == "Unknown"){
                recipientName = ""
                }
                const type = row.row.original.type

                let rowText;
                let iconPath;

                switch (subType) {
                case 'removed':
                    rowText = recipientName + " " + subType
                    break;
                case 'added':
                    rowText = recipientName + " " + subType
                    break;
                case 'changeRole':
                    rowText = recipientName + "'s " + eventData;
                    break;
                case 'suspended' :
                    rowText = recipientName + " was " + eventData;
                    break;
                case 'unsuspended' : 
                    rowText = recipientName + " was " + eventData;
                    break;
                case "OPEN_CLOSE_LOCKED":
                    rowText = eventData + " relocked";
                    break;
                case "OTP_UNLOCK":
                    rowText = eventData + " unlocked with OTP";
                    break;
                case "PIN_UNLOCK":
                    rowText = eventData
                    break;
                case "MASTER_PIN_UNLOCK":
                    rowText = eventData + " unlocked with master PIN";
                    break;
                case "UNOPENED_LOCKED":
                    rowText = eventData + " unlocked but not opened";
                    break;
                case "INCORRECT_PIN":
                    rowText = "Incorrect PIN was attempted on " + eventData;
                    break;
                case "Unlock":
                    rowText = eventData;
                    break;
                case "DELETE_PIN":
                    rowText = "Pincode deleted from " + eventData;
                    break;
                case "FIRST_DURATION_UNLOCK":
                    rowText = "Unlocked using Duration PIN"
                    break;
                case "BLE_PIN_CREATED":
                    rowText = "BLE Pin created for " + eventData
                    break;
                default:
                    rowText = eventData;
                }

                if (rowText.includes("linked to")){
                    let extra = ""
                    if (row.row.original.tag != ""){
                        extra = `(${row.row.original.tag})`
                    }
                    rowText = `Lock linked to ${row.row.original.key} ${extra}`
                }

                if (type === "Lock" || type === "IglooEvent"){
                if (subType === "Unlock"){
                    iconPath = iconMapping[4]
                } else if (subType === "OPEN_CLOSE_LOCKED") {
                    iconPath = iconMapping[3]
                } else if (subType === "OTP" || subType === "BLE_PIN_CREATED"){
                    iconPath = iconMapping[5]
                } else if (subType === "OTP_UNLOCK" || subType === "PIN_UNLOCK" || subType === "FIRST_DURATION_UNLOCK" || subType === "FIRST_PERMANENT_UNLOCK"){
                    iconPath = iconMapping[11]
                } else if (subType === "UNOPENED_LOCKED"){
                    iconPath = iconMapping[12]
                } else if (subType === "DELETE_PIN"){
                    iconPath = iconMapping[13]
                } else if (subType === "INCORRECT_PIN"){
                    iconPath = iconMapping[15]
                } else if (subType === "LINK"){
                    iconPath = iconMapping[16]
                } else if (subType === "UNLINK"){
                    iconPath = iconMapping[17]
                }
                } else if (type === "Input") {
                if (subType === "Armed"){
                    iconPath = iconMapping[7]
                } else {
                    iconPath = iconMapping[6]
                }
                } else if (type === "output") {
                if (subType === "Armed"){
                    iconPath = iconMapping[0]
                } else if (subType === "Disarmed"){
                    iconPath = iconMapping[1]
                } else {
                    iconPath = iconMapping[2]
                }
                } else if (type === "EfentoStatus"){
                iconPath = iconMapping[27]
                } else if (subType === "update" || subType === "Link" || subType === "Update"){
                iconPath = iconMapping[8]
                } else if (subType === "add" || subType === "Set" || subType === "Add" || subType === "Added" || subType === "Linked"){
                iconPath = iconMapping[9]
                } else if (subType === "added" ){
                iconPath = iconMapping[10]
                } else if (subType === "delete" || subType === "removed" || subType === "Delete"){
                iconPath = iconMapping[14]
                } else if (subType === "LINK"){
                iconPath = iconMapping[16]
                } else if (subType === "invited"){
                iconPath = iconMapping[18]
                } else if (subType === "offline"){
                iconPath = iconMapping[19]
                } else if (subType === "online"){
                iconPath = iconMapping[20]
                } else if (type === "ScheduledAction"){
                iconPath = iconMapping[21]
                } else if (subType === "accepted"){
                iconPath = iconMapping[22]
                } else if (subType === "left"){
                iconPath = iconMapping[23]
                } else if (type === "Camect"){
                iconPath = iconMapping[24]
                } else if (subType === "copyDeviceUsers"){
                iconPath = iconMapping[25]
                } else if (subType === "Override"){
                iconPath = iconMapping[26]
                } else if (eventData === "Logs cleared"){
                iconPath = iconMapping[14]
                } else if (subType === "Unlinked"){
                iconPath = iconMapping[14]
                } else if (subType === "changeRole"){
                iconPath = iconMapping[28]
                } else if (subType == "suspended" || subType == "unsuspended"){
                iconPath = iconMapping[27]
                } else if (type == "gateway"){
                    if (subType == "tamper"){
                        iconPath = iconMapping[27]
                    } else {
                        iconPath = iconMapping[29]
                    }
                }

                return (
                    <div  style={{ display: "flex",  alignItems: "center", gap: "10px" }}>
                    <div />
                    <img className={classes.img} src={iconPath}/>
                    <div className={classes.tableValueText}>
                    {rowText}
                    </div>
                    </div> 
                )
            }
        },
       
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Performed by</h3>
                </div> 
            ),
            accessorKey: 'performedBy',
            cell: (row) => {
                return (
                    <div className={classes.tableValueText}>
                        {row.row.original.performedBy}
                    </div>
                )
            }
        },
         {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Date</h3>
                </div> 
            ),
            accessorKey: 'eventDate',
            cell: (row) => {
                return (
                    <div className={classes.tableValueText}>
                       {format(new Date(row.row.original.eventDate), "MMMM do, yyyy - HH:mm")}
                    </div>
                )
            }
        }
    ]

    return (
        <div className={`${classes.table} ${classes.center} `}>
            <ListCard secondaryClassName={classes["Card-container"]}>
                <div className={classes["tableCardLayoutUI-wrapper"]} style={{ padding: "5px 10px 0px 10px" }}>
                    <Await resolve={events}>
                        {(loadedEvents) => {
                            return (
                                
                                    <BasicTable
                                        data={loadedEvents}
                                        columns={tableColumns}
                                        filtering={""}
                                        rowClick={false}
                                        ShowPagination={false}
                                        PageSize={5000}
                                        paginationOptions={[25, 50, 100]}
                                        showFilterButton={false}
                                        isSortable={true}
                                    />
                                
                            );
                        }}
                    </Await>
                </div>
            </ListCard>
        </div>
    );
}

export default PadlockEvents;